import React from 'react';
import Page from '../../layout/Page';
import Locations from './Locations';
import RoleProtected, { userRoles } from '../../RoleProtected';

const LocationsPage = () => (
    <RoleProtected roles={userRoles.accountConfiguration}>
        <Page title='Locations' icon='mobile'>
            <Locations />
        </Page>
    </RoleProtected>
);

export default LocationsPage;
